import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useSite } from '../context/SiteContext';

const Location: React.FC = () => {
  const { config, whatsappUrl } = useSite();

  const lat = config?.latitude || '';
  const lng = config?.longitude || '';
  const address = config?.address || '';

  const mapSrc = lat && lng
    ? `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d${lng}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s${encodeURIComponent(address)}!5e0!3m2!1spt-BR!2sbr`
    : address
      ? `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}&q=${encodeURIComponent(address)}`
      : '';

  if (!address && !mapSrc) return null;

  return (
    <section className="py-5 bg-profile-5">
      <Container>
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="text-profile-1 fw-bold mb-3">Nossa Localização</h2>
            {address && <p className="text-muted lead">Estamos estrategicamente localizados no centro de Apucarana para melhor atendê-lo</p>}
          </Col>
        </Row>

        <Row className="g-4">
          {mapSrc && (
            <Col lg={8}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="p-0">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={mapSrc}
                      width="100%" height="100%"
                      style={{ border: 0, borderRadius: '0.375rem' }}
                      allowFullScreen loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Localização"
                    ></iframe>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}

          <Col lg={mapSrc ? 4 : 12}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Body className="p-4">
                <h4 className="text-profile-1 fw-bold mb-4">
                  <i className="fas fa-map-marker-alt me-2 text-profile-3"></i>Endereço
                </h4>

                {address && (
                  <div className="mb-4">
                    <p className="text-muted mb-0">
                      <i className="fas fa-map-marker-alt me-2 text-profile-3"></i>{address}
                    </p>
                  </div>
                )}

                {config?.phone && (
                  <p className="text-muted mb-2">
                    <i className="fas fa-phone-alt me-2 text-profile-3"></i>
                    <a href={`tel:${config.phone.replace(/\D/g, '')}`} className="text-decoration-none text-muted">{config.phone}</a>
                  </p>
                )}

                {config?.whatsapp && (
                  <p className="text-muted mb-2">
                    <i className="fab fa-whatsapp me-2 text-profile-3"></i>
                    <a href={whatsappUrl} className="text-decoration-none text-muted" target="_blank" rel="noopener noreferrer">{config.whatsapp}</a>
                  </p>
                )}

                {config?.email && (
                  <p className="text-muted mb-4">
                    <i className="fas fa-envelope me-2 text-profile-3"></i>
                    <a href={`mailto:${config.email}`} className="text-decoration-none text-muted">{config.email}</a>
                  </p>
                )}

                {config?.business_hours && config.business_hours.length > 0 && (
                  <div className="mb-4">
                    <h6 className="fw-bold text-profile-1 mb-2">Horário de Funcionamento</h6>
                    <div className="text-muted small">
                      {config.business_hours.map((h, i) => (
                        <p className="mb-1" key={i}><i className="far fa-clock me-2 text-profile-3"></i>{h.day}: {h.hours}</p>
                      ))}
                    </div>
                  </div>
                )}

                {address && (
                  <div className="d-grid">
                    <a href={`https://maps.google.com/?q=${encodeURIComponent(address)}`} className="btn bg-profile-1 text-white" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-directions me-2"></i>Como Chegar
                    </a>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Location;
